import { booleanAttribute, Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: `
    a,
    a[acNavigationLink],
    a[acPrimaryLink],
    a[acSecondaryLink],
    a[acDropdownNavigationLink],
    a[acDropdownLangLink],
  `,
  standalone: true,
})
export class CustomLinkDirective {
  /** HOST CLASSES */
  @HostBinding('class.disabled')
  @Input({ transform: booleanAttribute })
  public disabled: boolean = false;

  /** HOST ATTRIBUTES */
  @HostBinding('attr.role') role: string = 'link';

  @HostBinding('attr.tabindex') tabIndex: number = 0;

  @Input({ transform: booleanAttribute }) negative?: boolean | string;
}
